import React, { useCallback, useMemo, useState } from "react";
import { DockSlotsContext } from "./DockSlotsContext";

export default function DockSlotsProvider({ children }) {
  const [slots, setSlots] = useState({});

  const registerSlot = useCallback((name, el) => {
    setSlots((prev) => {
      if (prev[name] === el) return prev;
      return { ...prev, [name]: el };
    });
  }, []);

  const value = useMemo(() => ({ slots, registerSlot }), [slots, registerSlot]);

  return (
    <DockSlotsContext.Provider value={value}>
      {children}
    </DockSlotsContext.Provider>
  );
}
